export default {
  presets: {
    light: {
      primary: '#22c55e',
      secondary: '#10b981',
      backgroundPrimary: '#f8fafc',
      backgroundSecondary: '#ffffff',
      backgroundCardPrimary: '#ffffff',
      backgroundCardSecondary: '#f1f5f9',
      backgroundElement: '#e2e8f0',
      backgroundBorder: 'rgba(0, 0, 0, 0.08)',
      textPrimary: '#0f172a',
      textSecondary: '#475569',
      textInverted: '#ffffff',
      menuBackground: '#ffffff',
      textMenuPrimary: '#0f172a',
      success: '#22c55e',
      info: '#06b6d4',
      danger: '#ef4444',
      warning: '#f59e0b',
      focus: '#22c55e',
      shadow: 'rgba(0, 0, 0, 0.1)',
    },
    dark: {
      primary: '#22c55e',
      secondary: '#10b981',
      backgroundPrimary: '#060b08',
      backgroundSecondary: '#0a110d',
      backgroundCardPrimary: '#0a110d',
      backgroundCardSecondary: '#0c1510',
      backgroundElement: '#132018',
      backgroundBorder: 'rgba(255, 255, 255, 0.06)',
      textPrimary: '#e2e8f0',
      textSecondary: '#94a3b8',
      textInverted: '#050816',
      menuBackground: '#0a110d',
      textMenuPrimary: '#e2e8f0',
      success: '#22c55e',
      info: '#06b6d4',
      danger: '#ef4444',
      warning: '#f59e0b',
      focus: '#22c55e',
      shadow: 'rgba(0, 0, 0, 0.4)',
    },
  },
}
